import styled, { css } from 'styled-components'

import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  ${({ theme }) => css`
    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.sm}px;
    `}

    ${theme.below.mobileXL`
      padding: 0 ${theme.newSpaces.xl}px;
      margin-top: ${theme.newSpaces.lg}px;
    `}
  `}
`

export const List = styled.ul`
  ${({ theme }) => css`
    list-style-image: url('/images/list-hexagon-dark.webp');
    margin: ${theme.newSpaces.sm}px auto ${theme.newSpaces.sm}px;
    padding-left: ${theme.newSpaces.sm}px;

    ${theme.below.tabletS`
      margin-bottom: ${theme.newSpaces.xs}px;
      list-style-image: none;
    `}
  `}
`

export const ListItem = styled.li`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body2')};

    color: ${theme.newColors.darkGray};
    margin-bottom: ${theme.newSpaces.xs}px;
    padding-left: ${theme.newSpaces.xs2}px;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body3')};

      font-weight: 300;
      margin: 0;
      margin-bottom: ${theme.newSpaces.xs2}px;
      padding-left: 0;
    `}
  `}
`

export const Title = styled.h2`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title1')};

    color: ${theme.newColors.primary};
    margin-bottom: ${theme.newSpaces.xs}px;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title1')};
      line-height: 34px;
    `}
  `}
`

export const SubTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.newColors.darkGray};
    white-space: pre-wrap;

    ${theme.getTypography('desktop', 'body', 'body2')}

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body4')}
    `}
  `}
`
